namespace app.documentos {

    export class VisualizadorBasicoDirective implements ng.IDirective {

        public restrict: string = "A";

        public static factory() {
            return ["$http", "$parse", "$window", "messagesService", "errorService",
                    ($http: ng.IHttpService, $parse: ng.IParseService, $window: ng.IWindowService,
                            messagesService: app.support.messaging.MessagesService) => {
                return new VisualizadorBasicoDirective($http, $parse, $window, messagesService);
            }];
        }

        public constructor(private $http: ng.IHttpService, private $parse: ng.IParseService,
                private $window: ng.IWindowService, private messagesService: app.support.messaging.MessagesService) {
            this.clickCallback = this.clickCallback.bind(this);
            this.link = this.link.bind(this);
        }

        public link(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes) {
            element.bind("click", () => this.clickCallback(scope, element, attrs));
            
            let apiExpression = attrs["stfVisualizadorBasicoApi"];
            if (apiExpression) {
                let api = this.$parse(apiExpression)(scope);
                if (api) {
                    api.open = () => {
                        let newTab;
                        if (!this.isIE()) {
                            newTab = this.openWindow();
                        }
                        return {
                            doOpen: () => {
                                this.clickCallback(scope, element, attrs, newTab);
                            },
                            close: () => {
                                if (newTab) {
                                    newTab.close();
                                }
                            }
                        }
                    }
                }
            }
        }

        private clickCallback(scope: ng.IScope, element: ng.IAugmentedJQuery, attrs: ng.IAttributes, existingTab = null) {
            const conteudo = attrs["stfVisualizadorBasico"];
            let newTab;
            if (conteudo.indexOf('base64') !== -1) {
                if (this.isIE()) {
                    throw "Base64 não é suportada no IE.";
                } else {
                    newTab = existingTab ? existingTab : this.openWindow();
                    this.openFileInTabAsBase64(conteudo, newTab);
                }
            } else {
                let url = this.$parse(conteudo)(scope);
                if (!this.isIE()) {
                    newTab = existingTab ? existingTab : this.openWindow(); // Necessário abrir a aba durante o evento do usuário para não causar bloqueio de pop-up.
                }
                this.$http.get(url, {responseType: "arraybuffer"}).then((response) => {
                    let blob = this.buildBlob(response.data);
                    if (this.isIE()) {
                        this.openFileIE(blob);
                    } else {
                        this.openFileInTab(blob, newTab);
                    }
                }, (error) => {
                    if (newTab) {
                        newTab.close();
                    }
                    this.messagesService.error("Erro ao carregar o PDF.");
                });
            }
        }
        
        private isIE(): boolean {
            return !!this.$window.navigator.msSaveOrOpenBlob;
        }
        
        private openWindow(): Window {
            return this.$window.open("", "_blank");
        }
        
        private buildBlob(data): Blob {
            return new Blob([data], {type: "application/pdf"});
        }
        
        private openFileInTabAsBase64(base64Data, tab): void {
            tab.location.href = base64Data;
        }
        
        private openFileInTab(blob: Blob, tab): void {
            let url = this.$window.URL.createObjectURL(blob);
            tab.location.href = url;
        }
        
        private openFileIE(blob: Blob): void {
            this.$window.navigator.msSaveOrOpenBlob(blob, "conteudo.pdf");
        }

    }

    angular.module("app.documentos").directive("stfVisualizadorBasico", VisualizadorBasicoDirective.factory());

}